import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component'
import { from } from 'rxjs';

const routes: Routes = [
	{
		path:'',component:LoginComponent,
	},
	{
		path: 'sadmin', loadChildren: () => import('./sadmin/sadmin.module').then(m => m.SadminModule)
  },
  {
		path: 'customer', loadChildren: () => import('./suser/suser.module').then(m => m.SuserModule)
	},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
